import React from "react";
import { titleWrapper, filtersWrapper, assignationWrapper } from '../styles';
import { DocumentSvg, DarkLogoTextSvg, CalendarSvg, MagnifyingGlassSvg, HomeSvg } from 'components/icons';
import { format } from 'date-fns';

export const PageHeader = ({ startDate, endDate, status, searchTerms, properties, groups, selectedPropertyIds, selectedGroupIds, report }) => {

  return (
    <div>
      <div style={titleWrapper}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <DocumentSvg width='26px' height='30px' color={window?.settings?.secondary_color ?? '#04333b'} />
          <div style={{ marginLeft: 13 }}>Inspections</div>
        </div>
        <DarkLogoTextSvg width='160px' height='63px' />
      </div>
      <div style={filtersWrapper}>
        {!report &&
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <DocumentSvg width='17px' height='17px' color={window?.settings?.primary_color ?? '#1DBD6B'} />
            <div style={{ marginLeft: 5 }}>{status.charAt(0).toUpperCase() + status.slice(1)}</div>
          </div>
        }
        <div style={{ display: 'flex', alignItems: 'center', marginLeft: 30 }}>
          <CalendarSvg width='15px' height='15px' color={window?.settings?.primary_color ?? '#1DBD6B'} />
          <div style={{ marginLeft: 13 }}>{`${format(startDate, 'MMMM dd yyyy')} to ${format(endDate, 'MMMM dd yyyy')}`}</div>
        </div>
        {searchTerms.length > 0 &&
          <div style={{ display: 'flex', alignItems: 'center', marginLeft: 30 }}>
            <MagnifyingGlassSvg width='15px' height='15px' color={window?.settings?.primary_color ?? '#1DBD6B'} />
            <div style={{ marginLeft: 10 }}>{searchTerms.join(', ')}</div>
          </div>
        }
      </div>
      <div style={assignationWrapper}>
        {selectedPropertyIds.map(id => {
          let property = properties.find(p => p.id === id);
          if (property) {
            return (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {property.icon && <img style={{ width: 13, height: 13, marginRight: 6 }} src={property.icon} />}
                <div style={{ marginRight: 12 }}>{property.name}</div>
              </div>
            )
          }
        })}
        {selectedGroupIds.map(id => {
          let group = groups.find(g => g.id === id);
          if (group) {
            return (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <HomeSvg width="13" height="13" color={window?.settings?.primary_color ?? '#1DBD6B'} style={{ marginRight: 6 }} />
                <div style={{ marginRight: 12 }}>{group.name}</div>
              </div>
            )
          }
        })}
      </div>
    </div>
  )
}